import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7661a9ba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "messages" }
const _hoisted_3 = { class: "message-til" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "message-type" }, "异常通知", -1))

import { ref } from 'vue'
import ComHeader from '@/components/ComHeader/index.vue'
import { IMessage } from '@/utils/interface'
import { getMessages } from '@/api/shop'
import store from '@/store'

// store.commit('user/setToken', '123')

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const list = ref<IMessage[] | null>(null)
getMessages({
  storeNo: store.getters.storeNo || '020120'
}).then((res: any) => {
  list.value = res.messageList
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_van_empty = _resolveComponent("van-empty")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ComHeader, {
      height: 16,
      title: "消息通知列表"
    }),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (item) => {
        return (_openBlock(), _createBlock(_component_router_link, {
          class: "message",
          key: item.exceptionId,
          "router-link": "",
          to: `/retrospect/${item.exceptionId}`
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("span", null, _toDisplayString(item.time), 1)
            ]),
            _createElementVNode("p", null, "门店名称：" + _toDisplayString(item.shopName), 1),
            _createElementVNode("p", null, "报警类型：" + _toDisplayString(item.messageInfo), 1)
          ]),
          _: 2
        }, 1032, ["to"]))
      }), 128))
    ]),
    (list.value && list.value.length === 0)
      ? (_openBlock(), _createBlock(_component_van_empty, {
          key: 0,
          image: "https://fastly.jsdelivr.net/npm/@vant/assets/custom-empty-image.png",
          "image-size": "80",
          description: "暂无数据"
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})